module.exports = __webpack_public_path__ + "static/media/Boom.b8403287.mp3";